import {translate} from "vue-gettext";

const {gettext: $gettext} = translate;

export default {
    PICA_STORAGE: 'pica_storage',
    JSON_ENDPOINT: 'json_endpoint',

    default() {
        return this.PICA_STORAGE
    },

    options() {
        return [
            {
                id: this.PICA_STORAGE,
                name: $gettext('Pica Storage')
            },
            {
                id: this.JSON_ENDPOINT,
                name: $gettext('JSON Endpoint')
            }
        ]
    }
}